module.exports = __webpack_public_path__ + "static/media/home_active.1d51be47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/home_active.svg
// module id = 1081
// module chunks = 36